/**
 * One map run's points: @ff/rank-map's RankGridData (version 1). A leaf module, so the reply recon's page record
 * (recon.ts, read by sites.ts) can use it without importing the reports API and its enums in a circle. Re-exported
 * from `reports` as `reports.GridPoints`, where it has always been. Added by WP-API.
 */
import { z } from 'zod';

const LatLngSchema = z.object({ lat: z.number().min(-90).max(90), lng: z.number().min(-180).max(180) });
export const GridPoints = z.object({
  version: z.literal(1),
  center: LatLngSchema,
  spacingMiles: z.number().positive().max(50),
  size: z.number().int().min(1).max(21),
  ranks: z.array(z.number().int().min(1).max(100).nullable()).max(441),
  keyword: z.string().max(120),
  measuredAt: z.string().max(40),
  business: z.object({ name: z.string().max(120), pin: LatLngSchema.optional() }).optional(),
  sample: z.boolean().optional(),
});
